export default "__VITE_ASSET__D1hza5oH__"